import { scrollToSection } from "../../utils/scrollTo";
import styles from "./Hero.module.css";

export default function Hero() {
  return (
    <section id="hero" className={styles.hero}>
      <div className={styles.bg} />
      <div className={styles.overlay} />

      <div className={styles.content}>
        <div className={styles.badge}>✦ Your Partner in Global Mobility ✦</div>

        <h1 className={styles.title}>
          The World<br />Awaits <em>You</em>
        </h1>

        <p className={styles.sub}>
          Premium travel management, visa assistance &amp; international career
          placement — from Nairobi to the world.
        </p>

        <div className={styles.btns}>
          <button className="btn-red" onClick={() => scrollToSection("Services")}>
            Explore Services
          </button>
          <button className="btn-ghost" onClick={() => scrollToSection("Contact")}>
            Get in Touch
          </button>
        </div>
      </div>

      <div className={styles.scrollHint} aria-hidden="true">
        <div className={styles.scrollLine} />
        <span>SCROLL</span>
      </div>
    </section>
  );
}
